var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgMp4 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 22,
    viewBox: "0 0 37 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.16833 3.5C2.39431 3.5 0.973684 4.94367 0.973684 6.70259V15.2974C0.973684 17.0563 2.39431 18.5 4.16833 18.5H32.8317C34.6057 18.5 36.0263 17.0563 36.0263 15.2974V6.70259C36.0263 4.94368 34.6057 3.5 32.8317 3.5H4.16833ZM0 6.70259C0 4.37174 1.87589 2.5 4.16833 2.5H32.8317C35.1241 2.5 37 4.37174 37 6.70259V15.2974C37 17.6283 35.1241 19.5 32.8317 19.5H4.16833C1.87589 19.5 0 17.6283 0 15.2974V6.70259Z",
    fill: "#9747FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9794 11.5138V12.8154L26.0561 12.8091V13.9872H27.6507V12.8091H28.4351V11.4605H27.6507V7.5H25.9564L22.9794 11.5138ZM24.5827 11.4669L26.186 9.30022V11.4669H24.5827Z",
    fill: "#9747FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9881 11.7481V13.9936H17.4129V7.58738H19.9674C20.7409 7.58738 21.3324 7.77698 21.7376 8.15407C21.9426 8.35217 22.1027 8.59071 22.2072 8.85398C22.3118 9.11725 22.3585 9.39932 22.3442 9.68161C22.3517 10.054 22.2582 10.4217 22.0734 10.7468C21.8841 11.0639 21.6037 11.3189 21.2674 11.4797C20.8618 11.669 20.4162 11.761 19.9674 11.7481H18.9881ZM20.7388 9.68161C20.7388 9.11349 20.4224 8.82943 19.7897 8.82943H18.9881V10.4976H19.7897C20.4224 10.5032 20.7388 10.2313 20.7388 9.68161Z",
    fill: "#9747FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3255 13.9936V7.63425L14.4188 7.64065L12.6855 12.0698L10.9262 7.64065H9V14H10.5752V10.014L11.9857 14H13.3485L14.7503 10.0225V13.9936H16.3255Z",
    fill: "#9747FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMp4);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mp4.2f7bc79d0d23e285f561eaa594fcf855.svg";